<div class="king-top">
  @if (kingService.game()?.hash) {
    <div animate.enter="fade-in" class="king__seed">
      <span class="king__seed-title">Hash:</span>
      <span
        class="king__seed-value"
        (click)="clipboardService.copy(kingService.game()!.hash!, 'Hash copied!')"
      >
        {{ kingService.game()?.hash }}
      </span>
    </div>
  }
  @if (kingService.game()?.gameid) {
    <app-fairness-button
      animate.enter="fade-in"
      [href]="'/provably-fair/king/' + kingService.game()?.gameid"
    />
  }
</div>

<div class="king__area">
  <app-king-side-top
    class="king__king"
    [user]="kingService.game()?.king ?? null"
  ></app-king-side-top>
  <div class="center-area-wrapper">
    <app-king-timer class="king-timer"></app-king-timer>
    <div class="king-swords-wrapper">
      <svg
        class="king-swords"
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.3547 20.7144L38.4168 22.8918L68.0348 53.1472L73.767 49.4799L78.5441 54.5225L72.5726 60.2527L80.9325 68.275L84.7545 66.4411L87.1429 70.3378L83.5601 75.6097L78.0664 79.0477L74.2448 76.5262L76.1558 72.8593L67.7959 64.837L61.8244 70.5671L56.5695 65.9828L60.3911 60.482L49.6429 50.8552L38.8945 60.482L42.955 65.9828L37.7002 70.5671L31.7289 64.837L23.369 72.8593L25.041 76.2973L21.2193 78.8184L15.7257 75.3803L12.1429 70.1085L14.7703 66.4411L18.5919 68.275L26.9518 60.2527L20.9805 54.5225L25.5187 49.7091L31.2512 53.3764L41.0442 43.2913L28.6238 32.2893L26.3547 20.7144ZM72.9311 20.7144L70.662 32.2893L62.7799 39.3948L53.9423 30.2265L60.8689 22.8918L72.9311 20.7144Z"
          fill="white"
          fill-opacity="0.16"
        />
      </svg>
    </div>
    <div class="king__provably">
      <button
        class="king-create button button--style-yellow padding-x-12 h-36"
        (click)="openDepositModal()"
      >
        <app-game-icon icon [game]="'King'" color="black"></app-game-icon>
        Join Game
      </button>
      <app-king-queue class="king-queue"></app-king-queue>
    </div>
  </div>
  <app-king-side-top
    class="king__challenger"
    [user]="kingService.game()?.part ?? null"
    [isChallenger]="true"
  ></app-king-side-top>
</div>

<div class="king-skins">
  <app-king-side-bottom
    [user]="kingService.game()?.king ?? null"
  ></app-king-side-bottom>
  <app-king-side-bottom
    [user]="kingService.game()?.part ?? null"
    [isChallenger]="true"
  ></app-king-side-bottom>
</div>
<div class="king-history">
  @for (game of kingService.history(); track $index) {
    <app-king-row animate.enter="list-enter" [game]="game"></app-king-row>
  }
</div>
